module.exports = __webpack_public_path__ + "media/images/flags/16/Canary-Islands-8f458155b71d8b4c7277887668d69772.png";